import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";
/**
 * CRETE API call using Axios
 * @returns - Save and submit Investigation api and return same object
 */

export const BNFFollowupAPI = async (params: { hasMovementSinceBNF: string, f18Note: string }, osdNumber: number) => {
  try {
    const response = await axios.post(`${getUrl(ApiType.BNF_FOLLOWUP).replace(":osdNumber", osdNumber.toString())}`, params);
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.bnfFollowUpAPIError, { badRequestOrder: "errorsFirst" });
  }
};
